import { CloudUploadOutlined, ExclamationOutlined, IssuesCloseOutlined, CheckOutlined, InfoCircleOutlined, QuestionOutlined, PauseOutlined, SettingOutlined, StopOutlined, ClockCircleOutlined, CloudSyncOutlined, WarningOutlined } from "@ant-design/icons"
import { Typography } from "antd";
import Pencil from '../assets/icons/pencil.svg?react';
import Loading from '../assets/icons/loading.svg?react';
import Still from '../assets/icons/still.svg?react';
import Info from '../assets/icons/info.svg?react';
import Render from '../assets/icons/render.svg?react';
import Check from '../assets/icons/check.svg?react';
const { Text } = Typography;

export enum AssetApprovalStatus {
    New = 0,
    Rejected = 10,
    RejectedButModified = 11,
    RejectedPendingModification = 12,
    Approved = 20,
    ApprovedButModified = 21,
    ApprovedPendingModification = 22,
    Quote = 30,
    Pending = 40,
    InProduction = 50,
    Commited = 60
}

export var AssetApprovalStatusLabels: { [key in AssetApprovalStatus]: string } = {
    0: "New",
    10: "Rejected",
    11: "Rejected but modified",
    12: "Rejected, with pending changes",
    20: "Approved",
    21: "Approved but modified",
    22: "Approved, with pending changes",
    30: "Quote",
    40: "Pending",
    50: "In production",
    60: "Commited"
}

export var AssetApprovalStatusOptions: { [key in AssetApprovalStatus]: React.ReactNode } = {
    0: <Text><CloudUploadOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.New]}</Text>,
    10: <Text type="danger"><ExclamationOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.Rejected]}</Text>,
    11: <Text type="warning"><IssuesCloseOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.RejectedButModified]}</Text>,
    12: <Text type="warning"><IssuesCloseOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.RejectedPendingModification]}</Text>,
    20: <Text type="success"><CheckOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.Approved]}</Text>,
    21: <Text type="warning"><InfoCircleOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.ApprovedButModified]}</Text>,
    22: <Text type="warning"><InfoCircleOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.ApprovedPendingModification]}</Text>,
    30: <Text><QuestionOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.Quote]}</Text>,
    40: <Text><PauseOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.Pending]}</Text>,
    50: <Text><SettingOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.InProduction]}</Text>,
    60: <Text><CloudUploadOutlined /> {AssetApprovalStatusLabels[AssetApprovalStatus.Commited]}</Text>
}

export enum ProjectStatus {
    Draft = 0,
    RenderingPreview = 10,
    RenderingFinal = 20,
    PreviewComplete = 40,
    FinalComplete = 50,
    Done = 60,
    Failed = 99,
}

export const ProjectStatusLabels: { [key in ProjectStatus]: string } = {
    0: 'Draft',
    10: 'Rendering preview',
    20: 'Rendering final images',
    40: 'Preview complete',
    50: 'Final images complete',
    60: 'Done',
    99: 'Failed',
}

export const ProjectStatusLabelsWithIcon: { [key in ProjectStatus]: React.ReactNode } = {
    0: <Text><Pencil /> Draft</Text>,
    10: <Text><Loading /> Rendering preview</Text>,
    20: <Text><Loading /> Rendering final images</Text>,
    40: <Text><Render /> Preview complete</Text>,
    50: <Text><Still /> Final images complete</Text>,
    60: <Text><Check/> Done</Text>,
    99: <Text><Info /> Failed</Text>,
}

export enum ProjectFolderStatus {
    Draft = 0,
    Done = 60
}

export const ProjectFolderStatusLabels: { [key in ProjectFolderStatus]: string } = {
    0: '',
    60: 'Done'
}

export const ProjectFolderStatusLabelsWithIcon: { [key in ProjectFolderStatus]: React.ReactNode } = {
    0: <Text></Text>,
    60: <Text><Check/> Done</Text>
}

export enum OrderStatus {
    Draft = 0,
    Placed = 10,
    Delegating = 20,
    Processing = 30,
    Declined = 40,
    ReadyForQA = 45,
    Deliverable = 50,
    DeliveryFailed = 53,
    Delivered = 60,
    Failed = 99
}

export const OrderStatusLabels: { [key in OrderStatus]: string } = {
    0: 'Draft',
    10: 'Placed',
    20: 'Delegating',
    30: 'Processing',
    40: 'Declined',
    45: 'ReadyForQA',
    50: 'Deliverable',
    53: 'DeliveryFailed',
    60: 'Delivered',
    99: 'Failed'
}

export enum OrderlineFileType {
    Still,
    Cutout,
    Spin,
    Clip,
    Animation
}

export enum AssetProjectStatus {
    New = 0,
    Quote = 1,
    InProduction = 2,
}

export var AssetProjectStatusLabels: { [key in AssetProjectStatus]: string } = {
    0: "New",
    1: "Quote",
    2: "In Production"
}

export enum AssetSourceType
{
    Unknown = 0,
    ExistingAsset = 1,
    Workflow = 2,
    None = 3,
    CADFile = 4,
    MaxFile = 5,
}

export var AssetSourceTypeLabels: { [key in AssetSourceType]: string } = {
    0: "Unknown",
    1: "Existing CoD asset",
    2: "Workflow",
    3: "None",
    4: "CAD File",
    5: "Max File"
}

export enum DAMTransferStatus {
    Pending,
    Queued,
    InProgress,
    Succeeded,
    Failed,
    Cancelled,
    Retrying
}

export var DAMTransferStatusLabels: { [key in DAMTransferStatus]: string } = {
    0: "Pending",
    1: "Queued",
    2: "InProgress",
    3: "Succeeded",
    4: "Failed",
    5: "Cancelled",
    6: "Retrying"
}

export var DAMTransferStatusOptions: { [key in DAMTransferStatus]: React.ReactNode } = {
    0: <Text><ClockCircleOutlined /> {DAMTransferStatusLabels[0]}</Text>,
    1: <Text type="danger"><CloudSyncOutlined /> {DAMTransferStatusLabels[1]}</Text>,
    2: <Text type="warning"><CloudUploadOutlined /> {DAMTransferStatusLabels[2]}</Text>,
    3: <Text type="success"><CheckOutlined /> {DAMTransferStatusLabels[3]}</Text>,
    4: <Text type="warning"><WarningOutlined /> {DAMTransferStatusLabels[4]}</Text>,
    5: <Text type="warning"><StopOutlined /> {DAMTransferStatusLabels[5]}</Text>,
    6: <Text><ClockCircleOutlined /> {DAMTransferStatusLabels[6]}</Text>,
}